export const OneDoorXLXXLCodes = ["schuifdeur", "taatsdeur", "paneel"];

export const TwoDoorXLXXLCodes = [
  "dubbel",
  "dubbeleschuifdeur",
  "taatsdeur1paneel",
  "schuifdeur1paneel",
  "paneelpaneel",
];

export const ThreeDoorXLXXLCodes = [
  "taatsdeur2paneel",
  "schuifdeur2paneel",
  "dubbel1paneel",
  "dubbeleschuifdeur1paneel",
  "taatsdeurpaneelpaneel",
  "schuifdeurpaneelpaneel",
  "schuifdeurpaneelschuifdeur",
  "schuifpaneelschuiftrap",
  "paneelpaneelpaneel",
];

export const FourDoorXLXXLCodes = [
  "dubbel2paneel",
  "dubbeleschuifdeur2paneel",
  "taatsdeurtaatsdeurpaneelpaneel",
  "paneelpaneelpaneelpaneel",
  "schuifdeurschuifdeurpaneelpaneel",
  "schuifdeurpaneelpaneelschuifdeur",
];

export const AllXLXXLDoorCodes = [
  ...OneDoorXLXXLCodes,
  ...TwoDoorXLXXLCodes,
  ...ThreeDoorXLXXLCodes,
  ...FourDoorXLXXLCodes,
];

export const newTextureXLXLDoors = [
  "dubbel2paneel",
  "dubbeleschuifdeur2paneel",
  "taatsdeurtaatsdeurpaneelpaneel",
  "paneelpaneelpaneelpaneel",
  "schuifdeurschuifdeurpaneelpaneel",
  "schuifdeurpaneelpaneelschuifdeur",
  "dubbeleschuifdeur",
  "dubbel",
  "paneelpaneelpaneel",
];

export const enabledXLXXLDeMaasDeWaalNewDoors = [
  "schuifdeur",
  "taatsdeur",
  "dubbel",
  "dubbeleschuifdeur",
];
